"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _country = require("../utils/country");

var _jsxRuntime = require("react/jsx-runtime");

var cdnUrl = 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.1/flags/4x3/';

function CountryFlag(props) {
  var style = props.size === 0 ? {} : {
    backgroundImage: "url(".concat(cdnUrl).concat(props.countryCode || _country.COUNTRY_CODE[props.country], ".svg)"),
    height: props.size,
    width: props.size * (4 / 3)
  };

  if (props.tooltipLabel) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Tooltip, {
      title: props.tooltipLabel,
      placement: "bottom",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flag",
        style: style
      })
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flag",
    style: style
  });
}

CountryFlag.propTypes = {
  country: _propTypes.default.string,
  countryCode: _propTypes.default.string,
  size: _propTypes.default.number,
  tooltipLabel: _propTypes.default.string
};
CountryFlag.defaultProps = {
  size: 20
};
var _default = CountryFlag;
exports.default = _default;
//# sourceMappingURL=CountryFlag.js.map